import { useState } from "react";
import { Col, Container, Dropdown, Row, Tab } from "react-bootstrap";
import {
  CstmPagination
} from "components/Common/Common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import moment from "moment";
import { usePersistentState } from "hooks/usePersistentState";
import TableLayoutV2 from "components/TableLayoutV2";
import { useCopyWorkshopMutation, useDeleteWorkshopMutation, useGetWorkshopsQuery } from "store/services/workshop";
import { dateFormat, successMessageToast, userFullName } from "helpers/common";
import { WORKSHOP_ADD, WORKSHOP_VIEW } from "config/paths";
import { useNavigate } from "react-router-dom";
import confirmDialogV2 from "utils/confirmationDialogV2";
// import ClassroomReportDateModal from "components/Modals/ClassroomReportDateModalV2";
import { reportDateFormat } from "config/constants";
import userImg from 'Assets/images/user.png';

const Workshops = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = usePersistentState("school:page", 1);
  const [pageSize, setPageSize] = useState(10);
  const [filter, setFilter] = useState({})
  const [copyReportDateModal, setCopyReportDateModal] = useState(false)
  const [currentEntry, setCurrentEntry] = useState(null)

  const { data, isLoading, isError, isFetching } = useGetWorkshopsQuery({ page: currentPage, limit: pageSize, ...filter });
  const [deleteWorkshop, { isLoading: deleteWorkshopLoading }] = useDeleteWorkshopMutation()
  const [copyWorkShhop, { isLoading: copyWorkshopLoading }] = useCopyWorkshopMutation()


  const workshops = data?.records;
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const column = [
    {
      head: "NAME",
      accessor: "title",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item?.title}</h6>
      ),
    },
    {
      head: "OWNER",
      accessor: "owner",
      isComponent: true,
      // sorter: true,
      component: (item, ind) => (
        <div className="d-flex gap-10 align-items-center">
          <img
            src={item?.workshopOwner?.therapist_detail?.profile_picture || userImg}
            alt="profile"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          /> {userFullName(item?.workshopOwner)}
        </div>
      ),
    },
    {
      head: "COLLABORATORS",
      accessor: "collaborators",
      isComponent: true,
      component: (item, ind) => (
        <div className="d-flex gap-10 align-items-center">
          {item?.collaborators?.length > 0 ? item?.collaborators?.map((collaborator) => (
            <img
              src={collaborator?.user?.therapist_detail?.profile_picture || userImg}
              alt="profile"
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />)) : <span>This note has no collaborators.</span>}
        </div>
      ),
    },
    {
      head: "DATE CREATED",
      accessor: "date",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <div>{moment(item?.date).isValid() ? dateFormat(item?.date, "MMMM DD, YYYY") : "--"}</div>
      ),
    },
    {
      head: "",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          {
            item?.status != "complete" &&
            <Dropdown
              onClick={(e) => e.stopPropagation()}
            // show={index == dropdownIndex}
            // onToggle={() => setDropdownIndex(index == dropdownIndex ? null : index)}
            >
              <Dropdown.Toggle
                variant="transparent"
                className="p-0 border-0 text-dark w-100"
                id="dropdown-basic"
              >
                <span className="icn ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="13"
                    viewBox="0 0 28 13"
                    fill="none"
                  >
                    <rect width="28" height="13" rx="6.5" fill="" />
                    <path
                      d="M23.2678 4.73223C22.2915 3.75592 20.7085 3.75592 19.7322 4.73223C18.7559 5.70854 18.7559 7.29146 19.7322 8.26777C20.7085 9.24408 22.2915 9.24408 23.2678 8.26777C24.2441 7.2915 24.2441 5.70858 23.2678 4.73223Z"
                      fill="#315D99"
                    />
                    <path
                      d="M16.2678 4.73223C15.2915 3.75592 13.7085 3.75592 12.7322 4.73223C11.7559 5.70854 11.7559 7.29146 12.7322 8.26777C13.7085 9.24408 15.2915 9.24408 16.2678 8.26777C17.2441 7.2915 17.2441 5.70858 16.2678 4.73223"
                      fill="#315D99"
                    />
                    <path
                      d="M9.26777 4.73223C8.29146 3.75592 6.70854 3.75592 5.73223 4.73223C4.75592 5.70854 4.75592 7.29146 5.73223 8.26777C6.70854 9.24408 8.29146 9.24408 9.26777 8.26777C10.2441 7.2915 10.2441 5.70858 9.26777 4.73223"
                      fill="#315D99"
                    />
                  </svg>
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
                <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                  <h5 className="cursor-pointer proxima mb-2" onClick={(e) => { handleCopyReport(e, item?.id); setCurrentEntry(item) }} style={{ borderBottom: "0.5px solid #000", padding: "13px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>Make a Copy</h5>
                  <h5 className="cursor-pointer proxima mb-2" onClick={(e) => { handleDelete(e, item?.id) }} style={{ padding: "13px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>Delete</h5>
                </ul>
              </Dropdown.Menu>
            </Dropdown>
          }
        </div>
      ),
    },
  ];

  const handleDelete = async (e, workshopId) => {
    e.stopPropagation();
    const isConfirm = await confirmDialogV2({
      title: "DELETE WORKSHOP",
      message: "Are you sure you want to delete this workshop?",
    });
    if (!isConfirm) {
      return;
    }
    try {
      const result = await deleteWorkshop({ workshopId }).unwrap()
      successMessageToast(result?.message)
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleCopyReportApi = async (workshopId, screening_date) => {
    try {
      await copyWorkShhop({ workshopId, screening_date }).unwrap()
      if (copyReportDateModal) {
        setCopyReportDateModal(false)
      }
    } catch (error) {
      console.log('error copying report:', error)
    }
  }
  const handleCopyReport = async (e, workshopId) => {
    e.stopPropagation();
    const isConfirm = await confirmDialogV2({
      title: "MAKE A COPY",
      message: `A copy of this workshop will be added to your list with ${moment().format(reportDateFormat)} as the Creation Date.`,
    });
    if (!isConfirm) {
      setCopyReportDateModal(true)
      return
    }
    else {
      handleCopyReportApi(workshopId, moment(new Date()).format("YYYY-MM-DD"))
    }
  }

  const handleFilterChange = (key) => (value) => {
    setFilter({ ...filter, [key]: value })
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };


  return (
    <>
      {/* <ClassroomReportDateModal
        show={copyReportDateModal}
        setShow={setCopyReportDateModal}
        currentEntry={currentEntry}
        handleCopyReportApi={handleCopyReportApi}
        isLoading={copyWorkshopLoading}
      /> */}
      <section className="client position-relative py-4">
        <Container fluid>
          {isLoading ? <div style={{ height: "200px" }}>  <LoadingIndicator /></div> : <Row>
            <div className="mt-4" style={{ paddingLeft: '12px', borderRadius: "4px" }}>

              <Row style={{ borderBottom: "2px solid gray" }} className="mx-1 pb-3 justify-content-between align-items-end" >
                <Col lg='6'>
                  <p className="twenty proxima-regular mb-0" style={{ color: "#000" }}>
                    Workshops
                  </p>
                </Col>
                <Col lg='2' style={{ textAlign: "center" }}>
                  <button
                    onClick={() => navigate(WORKSHOP_ADD)}
                    type="button"
                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                  // disabled={isFetching || submitting || copyReportLoading}
                  // isLoading={submitReportLoading || submitting}
                  >
                    Add New +
                  </button>

                </Col>
              </Row>
            </div>
            <Col lg="12" className="">
              <div className="table-outer">
                {isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching || deleteWorkshopLoading || copyWorkshopLoading) && <LoadingOverlay />}
                    {/* <TableLayout
                      data={schoolClients}
                      column={column}
                      url={SCHOOL_CLIENT_DETAIL.replace("/:id", "")}
                    // url={"/manage-team/therapist-profiles/detail/"}
                    /> */}
                    <TableLayoutV2
                      data={workshops}
                      column={column}
                      filter={filter}
                      url={WORKSHOP_VIEW.replace("/:id", "")}
                      handleSort={handleFilterChange("sort")}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  className={'paginationV2'}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>}
        </Container>
      </section>
    </>
  );
};

export default Workshops;
